export class SelectDto {
    public value: any;
    public text: string;
}

